







































































































import { Component, Vue } from "vue-property-decorator";
import adminUserService from "../../services/AdminUserService";
import securityService from "../../services/SecurityService";
import moment from 'moment';
var _ = require("underscore")._;

@Component
export default class AdminUser extends Vue {
  private inviteEmail = "";
  private inviteRole = "USER";
  private submitted = false;
  private adminUsers: any = { records: [], totalRecords: 0 };
  private selectAll: boolean = false;
  private selected: any = [];
  private currentPage: number = 1;
  private search: string = "";
  private filter: any = { name: "" };
  private roleOptions = [
    {
      text: "USER",
      val: "USER"
    },
    {
      text: "ADMIN",
      val: "ADMIN"
    }
  ];
  private status: any = [
    { text: "Active", value: "A" },
    { text: "Inactive", value: "I" },
    { text: "Waiting", value: "W" }
  ];
  private adminUserFields: any = [
    {
      key: "email",
      label: "Email"
    },
    {
      key: "role",
      label: "Role"
    },
    {
      key: "createdDate",
      label: "Created date"
    },
    {
      key: "updatedDate",
      label: "Updated date"
    },
    {
      key: "status",
      label: "Status"
    },
    {
      key: "actions",
      label: ""
    }
  ];

  created() {
    this.getAdminUsers();
  }

  getAdminUsers() {
    adminUserService
      .getAdminUsers()
      .then((response: any) => {
        this.adminUsers.records = response.data;
        this.adminUsers.totalRecords = response.data.length;
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  formatdate(dateTiem: any) {
    if (dateTiem) {
      return moment(String(dateTiem)).format('DD/MM/YYYY hh:mm:ss');
    }
  }

  showStatus(status: any) {
    return _.findWhere(this.status, { value: status }).text;
  }

  handleInvite() {
    this.submitted = true;
    this.$validator.validate().then(valid => {
      if (valid) {
        const email = this.inviteEmail;
        const role = this.inviteRole;
        adminUserService
          .inviteUser(email, role)
          .then((response: any) => {
            const inviteToken = response.data.inviteToken;
            this.$swal({
              confirmButtonColor: "#28a745",
              title: "Invite URL",
              text: `${window.location.origin}/invite?token=${inviteToken}`,
              type: "success"
            });
            this.getAdminUsers();
            this.inviteEmail = "";
            this.submitted = false;
          })
          .catch((error: any) => {
            this.$swal({
              title: `Email Already Exists`,
              type: "error"
            });
          });
      }
    });
  }

  handleSearch() {
    this.search = this.filter.name;
  }

  filteredList() {
    let list = this.adminUsers.records.filter((c: any) => {
      const email = c.email.toLowerCase().includes(this.search.toLowerCase());
      return email;
    });
    this.adminUsers.totalRecords = list.length;
    return list;
  }

  showURL(id: number, txt: string) {
    adminUserService
      .getInvite(txt)
      .then((response: any) => {
        const inviteToken = response.data.inviteToken;

        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Invite URL",
          text: `${window.location.origin}/invite?token=${inviteToken}`
        });
      })
      .catch((error: any) => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }

  reInvite(id: number, txt: string) {
    adminUserService
      .reInviteUser(txt)
      .then((response: any) => {
        const inviteToken = response.data.inviteToken;

        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Re-Invite URL",
          text: `${window.location.origin}/invite?token=${inviteToken}`
        });
      })
      .catch((error: any) => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }

  deleteConfirm(id: number, txt: string) {
    this.$swal({
      title: "Are you sure?",
      text: `You want to delete user ${txt}!`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(result => {
      if (result.value) {
        this.deleteAdminUser(txt);
      }
    });
  }

  deleteAdminUser(txt: string) {
    this.$swal({
      title: "Waiting",
      timer: 3000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        this.$swal.showLoading();
      }
    });

    adminUserService
      .deleteAdminUser(txt)
      .then((response: any) => {
        this.getAdminUsers();
        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Complete",
          type: "success"
        });
      })
      .catch((error: any) => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }

  displayMusicLabel(musicLabel: any) {
    return musicLabel ? `${musicLabel.name} / ${musicLabel.nameEN}` : "";
  }
}
